import { StageData, STAGES } from "@/game/stages/StageData";

/**
 * ステージ選択UI — カスタムドロップダウン
 *
 * Header 内の .stage-select コンテナにマウントされる。
 * ボタンクリックでパネルを開閉し、ステージを選択する。
 */
export class StageSelector {
  private btn: HTMLButtonElement;
  private panel: HTMLElement;
  private selectedStageId: number = 1;
  private onSelectCallback?: (stage: StageData) => void;

  constructor(parentElement: HTMLElement) {
    // トリガーボタン
    this.btn = document.createElement("button");
    this.btn.className = "stage-select__btn";
    this.btn.setAttribute("aria-label", "ステージ選択");
    this.btn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.panel.classList.toggle("open");
    });
    parentElement.appendChild(this.btn);

    // ドロップダウンパネル
    this.panel = document.createElement("div");
    this.panel.className = "stage-select__panel";
    parentElement.appendChild(this.panel);

    // 外部クリックで閉じる
    document.addEventListener("click", () => {
      this.panel.classList.remove("open");
    });

    this.renderBtn();
    this.renderPanel();
  }

  onSelect(callback: (stage: StageData) => void): void {
    this.onSelectCallback = callback;
  }

  getSelectedStage(): StageData {
    return STAGES.find((s) => s.id === this.selectedStageId) || STAGES[0];
  }

  private renderBtn(): void {
    const stage = this.getSelectedStage();
    this.btn.textContent = "";
    const text = document.createTextNode(`${stage.id}: ${stage.name} `);
    this.btn.appendChild(text);
    const arrow = document.createElement("span");
    arrow.className = "stage-select__arrow";
    arrow.textContent = "▼";
    this.btn.appendChild(arrow);
  }

  private renderPanel(): void {
    this.panel.replaceChildren();

    STAGES.forEach((stage) => {
      const item = document.createElement("button");
      item.className = "stage-item";
      if (stage.id === this.selectedStageId) {
        item.classList.add("stage-item--active");
      }
      item.setAttribute("aria-label", `ステージ${stage.id}: ${stage.name}`);

      // 番号バッジ
      const num = document.createElement("span");
      num.className = "stage-item__num";
      num.textContent = String(stage.id);
      item.appendChild(num);

      // ステージ名
      const name = document.createElement("span");
      name.className = "stage-item__name";
      name.textContent = stage.name;
      item.appendChild(name);

      // MP
      const mp = document.createElement("span");
      mp.className = "stage-item__mp";
      mp.textContent = `MP ${stage.mp}`;
      item.appendChild(mp);

      // ステータス（プレースホルダ — クリア状態追跡は未実装）
      const status = document.createElement("span");
      status.className = "stage-item__status";
      item.appendChild(status);

      item.addEventListener("click", (e) => {
        e.stopPropagation();
        this.selectStage(stage.id);
        this.panel.classList.remove("open");
      });

      this.panel.appendChild(item);
    });
  }

  private selectStage(stageId: number): void {
    this.selectedStageId = stageId;
    this.renderBtn();
    this.renderPanel();

    const stage = this.getSelectedStage();
    this.onSelectCallback?.(stage);
  }
}
